<template>
    <div v-resize="ScrUpdate"> {{ ActDescBtn }}
        <table style="position: absolute;" width="100%" :height="this.windowSize.height - 8"
            :max-height="this.windowSize.height - 8">
            <!-- Botones de accion en barra -->
            <tr max-height="48px" height="48px">
                <ContenidoBase :titulo="'Fecha de Vencimiento'"
                    :descripcion="'Crear, buscar y eliminar Fecha de Vencimiento'" :EstadoBtn="EstadoBtn"
                    @abrirBarraTablaDinamica="abrirTabla" @MethodNuevo="newwnuevo" @MethodGuardar="save"
                    @MethodEliminar="NotifMessageEliminar" @MethodAnular="NotifMessageAnular"
                    @MethodImprimir="imprimirList" />
            </tr>
            <!-- Botones de accion en barra -->
            <tr>
                <!-- INICIO BARRA LATERAL  --------------------------------------------------------------------------------->
                <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraTablaDinamicaAprir">

                    <div class="overflow-y-auto "
                        v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <center>
                                    <v-btn-toggle>
                                        <v-btn small color="yellow accent-4" @click.prevent="actualiza_tb_ver">
                                            <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn>
                                    </v-btn-toggle>
                                </center>

                                <BarraDinamicaNormal :nombre="'Fecha de Vencimiento'" @EmitDAta="datostabla"
                                    @EmitBuscar="filtro" :SeachNombre="'Búsqueda general'" :list="list" :headers="[
                                        { text: 'código', value: 'codigo' },
                                        { text: 'Periodo', value: 'periodo' },
                                        { text: 'Fecha inicio', value: 'fechaInicial' },
                                        { text: 'Fecha fin', value: 'fechaFinal' },

                                    ]" :ContListSlot="[
                                        { Text: 'Código', NomValue: 'codigo', Ctsl: 1, Type: 0, State: true },
                                        { Text: 'Periodo', NomValue: 'periodo', Ctsl: 1, Type: 0, State: true },
                                        { Text: 'Fecha inicio', NomValue: 'fechaInicial', Nv2: 'FechaInicial', Ctsl: 1, Type: 1, State: true },
                                        { Text: 'Fecha fin', NomValue: 'fechaFinal', Nv2: 'fechaFinal', Ctsl: 1, Type: 1, State: true },
                                    ]" />
                            </template>
                        </v-tooltip>

                    </div>
                </td>
                <!-- FIN BARRA LATERAL  ---------------------------------------------------------------------------------->
                <!-- INICIO CONTENIDO PRINCIPAL ------------------------------------------------------------------------------ -->
                <td :max-height="this.windowSize.height - 96">
                    <v-app id="inspire" class="overflow-y-auto "
                        v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">

                        <div class="px-2">
                            <v-card color="grey lighten-3">

                                <div class="px-2">
                                    <v-form ref="formFechaVencimiento" @submit.prevent="" v-model="valid"
                                        lazy-validation>
                                        <v-row>

                                            <v-col cols="12" md="6" sm="6">
                                                <v-text-field id="formdisabledInput" label="Codigo:" dense outlined
                                                    v-model="FechaVencimiento.codigo" :disabled="true"
                                                    style="font-size: 13px;">
                                                    <template v-slot:prepend>
                                                        <i style="font-size: 20px;" class="fa fa-list-ol"></i>
                                                    </template>
                                                </v-text-field>
                                                <v-row>
                                                    <v-col>
                                                        <v-text-field dense outlined label="Año inicial" type="number"
                                                            style="font-size: 13px;" min="2000" max="2100"
                                                            v-model="FechaVencimiento.yearInicial"
                                                            @input="$refs.formFechaVencimiento.validate()"
                                                            :rules="[$rules.required, validateYear]">
                                                            <template v-slot:prepend>
                                                                <i style="font-size: 20px;" class="fa fa-calendar"></i>
                                                            </template>
                                                        </v-text-field>
                                                    </v-col>

                                                    <v-col>
                                                        <v-text-field dense outlined label="Año final" type="number"
                                                            style="font-size: 13px;" min="2000" max="2100"
                                                            v-model="FechaVencimiento.yearFinal"
                                                            @input="$refs.formFechaVencimiento.validate()"
                                                            :rules="[$rules.required, validateYear]">
                                                            <template v-slot:prepend>
                                                                <i style="font-size: 20px;" class="fa fa-calendar"></i>
                                                            </template>
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-combobox dense outlined label="Mes inicial" :items="meses"
                                                    style="font-size: 13px;" :rules="[$rules.required, processMonth]"
                                                    v-model="mesSeleccionado">
                                                    <template v-slot:prepend>
                                                        <i style="font-size: 20px;" class="fa fa-calendar"></i>
                                                    </template>
                                                </v-combobox>
                                            </v-col>

                                            <v-col cols="12" md="6" sm="6">
                                                <h3>Seleccione un periodo</h3>
                                                <v-radio-group dense v-model="FechaVencimiento.periodo">
                                                    <v-radio label="Semanal" value="semanal"></v-radio>
                                                    <v-radio label="Quincenal" value="quincenal"></v-radio>
                                                    <v-radio label="Mensual" value="mensual"></v-radio>
                                                </v-radio-group>
                                                <v-btn color="primary" dark @click="previewGeneration"
                                                    :disabled="EstadoBtn.eliminar === true">
                                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                                    Generar vista previa
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </div>
                            </v-card>
                        </div>

                        <div class="mt-2 px-2" transition="fade-transition">
                            <v-card class="grey lighten-3">
                                <v-data-table :headers="[
                                    { text: 'Código', value: 'codigo', sortable: false, class: ['no-gutters black--text'] },
                                    { text: 'Periodo', value: 'periodo', sortable: false, class: ['no-gutters black--text'] },
                                    { text: 'Fecha inicio', value: 'fechaInicial', sortable: false, class: ['no-gutters black--text'] },
                                    { text: 'Fecha fin ', value: 'fechaFinal', sortable: false, class: ['no-gutters black--text'] },
                                    { text: 'Año inicial', value: 'yearInicial', sortable: false, class: ['no-gutters black--text'] },
                                    { text: 'Año final', value: 'yearFinal', sortable: false, class: ['no-gutters black--text'] }
                                ]" dense :items="previewList">
                                    <template v-slot:item.fechaInicial="{ item }">
                                        {{ FormatoFecha(item.fechaInicial) }}
                                    </template>
                                    <template v-slot:item.fechaFinal="{ item }">
                                        {{ FormatoFecha(item.fechaFinal) }}
                                    </template>
                                </v-data-table>
                            </v-card>
                        </div>

                    </v-app>
                </td>
                <!-- FIN CONTENIDO PRINCIPAL ------------------------------------------------------------------------------------->
                <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
                <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraSecundariaAprir">
                    <div class="overflow-y-auto "
                        v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">
                    </div>
                </td>
                <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
            </tr>
        </table>
        <!-- Modales -------------------------------------------------------------------------------------------------->
        <!-- ------------------------------------------------------ tb-data todo general -->
        <v-dialog label="myAlert" v-model="acti_tb_data" persistent transition="dialog-bottom-transition" fullscreen
            hide-overlay>
            <v-card>
                <v-toolbar dense flat color="#BDBDBD">
                    <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
                    <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
                    <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
                        <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-card>
                        <v-card-title>
                            <v-text-field v-model="search" @keyup="filtro" label="Buscar" single-line hide-details>
                                <template v-slot:prepend-inner>
                                    <i style="font-size: 35px;" class="fa fa-search"></i>
                                </template>
                            </v-text-field>
                        </v-card-title>

                        <v-data-table :headers="[
                            { text: 'código', value: 'codigo', sortable: false, class: ['no-gutters black--text'] },
                            { text: 'Periodo', value: 'periodo', sortable: false, class: ['no-gutters black--text'] },
                            { text: 'Fecha inicio', value: 'fechaInicial', sortable: false, class: ['no-gutters black--text'] },
                            { text: 'Fecha fin ', value: 'fechaFinal', sortable: false, class: ['no-gutters black--text'] },
                            { text: 'Año inicial', value: 'yearInicial', sortable: false, class: ['no-gutters black--text'] },
                            { text: 'Año final', value: 'yearFinal', sortable: false, class: ['no-gutters black--text'] }
                        ]" dense :items="list" :search="search" @click:row="datostabla">
                            <template v-slot:item.fechaInicial="{ item }">
                                {{ FormatoFecha(item.fechaInicial) }}
                            </template>
                            <template v-slot:item.fechaFinal="{ item }">
                                {{ FormatoFecha(item.fechaFinal) }}
                            </template>
                        </v-data-table>

                        <!-- <template v-slot:item.fechaIngreso="props">
                                <span>{{ FormatoFecha(props.item.fechaIngreso) }}</span>
                            </template> -->
                        </v-data-table>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- ------------------------------------------------------ fb tb-data todo general -->
        <!-- ------------------------------------------------------ Modal-notificacion general -->
        <v-dialog label="myAlert" v-model="notif.estado" persistent max-width="350" transition="fab-transition">
            <template justify="center" v-slot:activator="{ on }"></template>

            <v-card>
                <v-card-title>
                    <h4>
                        <i style="font-size: 28px;" class="fa fa-warning"></i>
                        CONFIRMACION
                        <i style="font-size: 28px;" class="fa fa-warning"></i>
                    </h4>
                </v-card-title>
                <hr />

                <v-card-text>
                    <h5>{{ notif.nombre }}</h5>
                </v-card-text>

                <hr />
                <v-card-actions>
                    <v-btn v-if="notif.Exec == 'eliminarFechaVencimiento'"
                        @click.prevent="eliminar(), (notif.estado = !notif.estado)" small>
                        <i style="font-size: 20px;" class="fa fa-check"></i> Si
                    </v-btn>
                    <v-btn v-if="notif.Exec == 'anularFechaVencimiento'"
                        @click.prevent="anular(), (notif.estado = !notif.estado)" small>
                        <i style="font-size: 20px;" class="fa fa-check"></i> Si
                    </v-btn>

                    <v-btn @click.prevent="notif.estado = !notif.estado" small>
                        <i style="font-size: 20px;" class="fa fa-ban"></i> No
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- ------------------------------------------------------  fn Modal-notificacion general -->
        <!------------otras funciones---------------->
        <v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%;" :vertical="true"
            :timeout="120000" top="top">
            {{ aalert.nombre }}
            <v-btn dark text @click="aalert.estado = false">Close</v-btn>
        </v-snackbar>

        <!-- fn Modales ----------------------------------------------------------------------------------------------->
    </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import BarraDinamicaNormal from "../../components/BarraDinamicaNormalPlus.vue";
import ContenidoBase from "../../components/ContenidoBase";
import ComponentsClienteBasico from "@/CuentaXCobrar/Mant/ClientesBasico.vue";
import { FormatoFecha } from "@/js/Funciones";

export default {
    components: {
        BarraBusqueda2,
        ContenidoBase,
        ComponentsClienteBasico,
        BarraDinamicaNormal
    },

    created() {
        var json = {
            titulo: "Fecha de Vencimiento",
            descripcion: "Crear, Modificar y eliminación de Fecha de Vencimiento",
            save: false,
            eliminar: false,
            anular: false,
            nuevo: false,
            imprimir: false,
            btnBarraDi: false,

            accion: [
                "FechaVencimientoNew",
                "FechaVencimientoSave",
                "FechaVencimientoRemove",
                "FechaVencimientoAnular",
                "FechaVencimientoPrintList"
            ],
        };
        EventBus.$emit("anularBotonesAccion", json);
    },
    mounted() {
        // EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
        // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
        // EventBus.$on("FechaVencimientoNew", this.new);
        // EventBus.$on("FechaVencimientoSave", this.save);
        // EventBus.$on("FechaVencimientoRemove", this.remove);
        // EventBus.$on("FechaVencimientoAnular", this.remove);
        // EventBus.$on("FechaVencimientoPrintList", this.imprimirList);
        // EventBus.$on("emitFechaVencimiento", this.datostabla);
    },

    data: () => ({
        windowSize: { width: "auto", height: "auto" },
        FechaVencimiento: {
            codigo: 0,
            yearInicial: 2025,
            yearFinal: 2025,
            mesInicial: 1,
            periodo: "semanal",
            activo: true,
            borrado: false
        },
        meses: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        mesSeleccionado: "Enero",
        previewList: [],

        EstadoBtn: {
            BarraTablaDinamicaAprir: false,
            nuevo: false,
            guardar: false,
            eliminar: false,
            anular: false,
            imprimir: false,
            vercuenta: false,
            guardartemporal: false,
            restaurartemporal: false,
            importarDato: false,
            cargarProducto: false,
            ImprimirproductoInv: false,
        },

        text: "",
        valid: true,
        ejecucion: true,
        BarraTablaDinamicaAprir: false,
        BarraSecundariaAprir: false,

        headers: [{ text: "Tipo Clientes", value: "descripcion" }],

        slotlist: [
            { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
            {
                dt0: "descripcion",
                dt1: null,
                dt2: null,
                dt3: 1,
                dt4: "Descripcion:"
            },
            { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
        ],

        list: [],
        search: "",
        acti_tb_data: false,

        notif: {
            estado: false,
            nombre: "",
            Exec: ""
        },

        aalert: {
            estado: false,
            color: null
        },

    }),

    methods: {
        FormatoFecha,
        previewGeneration() {
            this.previewList = [];
            const mesIndex = this.meses.findIndex(mes => mes === this.mesSeleccionado) + 1;

            const fechaVencimiento = { ...this.FechaVencimiento };
            fechaVencimiento.mesInicial = mesIndex;

            const yearMax = +fechaVencimiento.yearFinal + 1;
            const periodo = fechaVencimiento.periodo;

            // Crear la fecha inicial
            let fechaInicio = new Date(fechaVencimiento.yearInicial, mesIndex - 1, 1);

            // Calcular la fecha final según el periodo
            let fechaFin = this.calcularFechaFinSegunPeriodo(fechaInicio, periodo);

            // Generar las fechas de vencimiento y añadirlas a la lista de vista previa
            let contador = 1;

            // Usamos una condición mejorada para incluir ambos años
            while (fechaInicio.getFullYear() < yearMax) {
                // Crear una nueva copia del objeto para cada entrada
                let item = {
                    ...fechaVencimiento,
                    codigo: contador,
                    fechaInicial: fechaInicio.getTime(),
                    fechaFinal: fechaFin.getTime()
                };

                this.previewList.push(item);
                contador++;

                // Avanzar las fechas según el periodo
                switch (periodo) {
                    case "semanal":
                        fechaInicio = new Date(fechaInicio);
                        fechaInicio.setDate(fechaInicio.getDate() + 7);
                        fechaFin = new Date(fechaFin);
                        fechaFin.setDate(fechaFin.getDate() + 7);
                        break;
                    case "quincenal":
                        fechaInicio = new Date(fechaInicio);
                        fechaInicio.setDate(fechaInicio.getDate() + 15);
                        fechaFin = new Date(fechaFin);
                        fechaFin.setDate(fechaFin.getDate() + 15);
                        break;
                    case "mensual":
                        let nextMonth = fechaInicio.getMonth() + 1;
                        let nextYear = fechaInicio.getFullYear();
                        if (nextMonth > 11) {
                            nextMonth = 0;
                            nextYear++;
                        }
                        fechaInicio = new Date(nextYear, nextMonth, 1);
                        fechaFin = this.calcularFechaFinSegunPeriodo(fechaInicio, periodo);
                        break;
                }
            }
        },
        calcularFechaFinSegunPeriodo(fechaInicio, periodo) {
            const fechaFin = new Date(fechaInicio);

            switch (periodo) {
                case "semanal":
                    fechaFin.setDate(fechaFin.getDate() + 6);
                    break;
                case "quincenal":
                    fechaFin.setDate(fechaFin.getDate() + 14);
                    break;
                case "mensual":
                    // Obtener el último día del mes
                    const year = fechaInicio.getFullYear();
                    const month = fechaInicio.getMonth();
                    // El día 0 del siguiente mes es el último día del mes actual
                    fechaFin.setFullYear(year, month + 1, 0);
                    break;
                default:
                    throw new Error("Periodo no válido: " + periodo);
            }
            return fechaFin;
        },
        processMonth() {
            if (!this.meses.includes(this.mesSeleccionado)) {
                return "Invalido"
            }
            this.FechaVencimiento.mesInicial = this.meses.indexOf(this.mesSeleccionado) + 1
            return true
        },
        validateYear() {
            return this.FechaVencimiento.yearInicial > this.FechaVencimiento.yearFinal
                ? "Invalido" : true
        },
        printAll() {
            console.log(this.FechaVencimiento);
        },
        ScrUpdate() {
            // var jsn = {width:window.innerWidth, height:window.innerHeight-112 }
            // this.onResize(jsn)
        },
        onResize(e) {
            // console.log("impriioooooooooooooooooooo ")
            // console.log(e)
            // this.windowSize= JSON.parse(JSON.stringify(e))
        },
        // Alternando el valor de la variable BarraTablaDinamicaAprir.
        abrirTabla() {
            this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;
            if (this.BarraTablaDinamicaAprir == true) {
                this.filtro()
            }
        },
        async cargarTodo() {
        },
        // Asignar el objecto seleccionado al formulario.
        datostabla(e) {
            var obj = JSON.parse(JSON.stringify(e))
            this.FechaVencimiento = JSON.parse(JSON.stringify(obj));
            this.mesSeleccionado = this.meses.at(this.FechaVencimiento.mesInicial - 1)


            this.previewList = this.list
                .filter((fecha) => fecha.mesInicial == this.FechaVencimiento.mesInicial)
                .filter((fecha) => fecha.yearInicial == this.FechaVencimiento.yearInicial)
                .filter((fecha) => fecha.yearFinal == this.FechaVencimiento.yearFinal)
                .filter((fecha) => fecha.periodo == this.FechaVencimiento.periodo)
            this.acti_tb_data = false
        },
        // Envío de una solicitud POST al servidor guardando las fechas de vencimiento.
        save() {
            if (this.$refs.formFechaVencimiento.validate()) {
                if (this.previewList.length === 0) {
                    this.alerta("Debe generar una vista previa antes de salvar", "error")
                    return
                }
                var json = JSON.parse(JSON.stringify(this.FechaVencimiento))
                if (this.ejecucion == true) {
                    this.ejecucion = false
                    this.$axios
                        .post(this.$hostname + this.$hName + "/fechaVencimiento", this.FechaVencimiento, { headers: this.$store.getters.GetheadersAxios })
                        .then(res => { this.filtro(), console.log(res.data), this.alerta("Dato guardado correctamente!", "bien") })
                        .catch(error => this.alerta("Dato no guardado correctamente", "error"));
                }
            } else {
                this.alerta("Los campos en rojo son requeridos", "error");
            }
        },
        NotifMessageAnular() {
            if (this.FechaVencimiento.codigo != 0 && this.FechaVencimiento.codigo != null) {
                var notif = {
                    estado: true,
                    nombre: "¿Seguro que desea Anular este Registro?",
                    Exec: "anularFechaVencimiento"
                }
                this.Exec_notif(notif)

            } else { this.alerta("Seleccione un tipo de impuesto para eliminar", "error") }
        },
        NotifMessageEliminar() {

            if (this.FechaVencimiento.codigo != 0 && this.FechaVencimiento.codigo != null) {
                var notif = {
                    estado: true,
                    nombre: "¿Seguro que desea eliminar este Registro?",
                    Exec: "eliminarFechaVencimiento"
                }

                this.Exec_notif(notif)
            } else { this.alerta("Seleccione una fecha de vencimiento para eliminar", "error") }
        },

        Exec_notif(e) {
            this.notif = JSON.parse(JSON.stringify(e))
        },

        // Enviando una solicitud POST al servidor con los datos en la variable jsn.
        eliminar() {
            const codigo = this.FechaVencimiento.codigo
            this.$axios
                .delete(this.$hostname + this.$hName + `/fechaVencimiento/${codigo}`, { headers: this.$store.getters.GetheadersAxios })
                .then(res => {
                    this.alerta(res.data, "bien")
                    this.filtro()
                })
                .catch(error => this.alerta("Dato no eliminado correctamente", "error"));
        },
        // Envío de una solicitud POST al servidor.
        anular() {
            var jsn = JSON.parse(JSON.stringify(this.FechaVencimiento))
            this.$axios
                .post(this.$hostname + this.$hName + "/internamientos/anular/", jsn, { headers: this.$store.getters.GetheadersAxios })
                .then(res => { this.alerta(res.data.mensage, res.data.estado) })
                .catch(error => this.alerta("Dato no guardado correctamente", "error"));
        },
        imprimirList() { },
        // Creando un nuevo objeto y asignándolo a la variable FechaVencimiento.
        newwnuevo() {
            this.FechaVencimiento = {
                codigo: 0,
                yearInicial: 2025,
                yearFinal: 2025,
                mesInicial: 1,
                periodo: "semanal",
                activo: true,
                borrado: false
            },
                this.previewList = []
            this.mesSeleccionado = "Enero"
            this.ejecucion = true;
            EventBus.$emit("actualizaBarraBusqueda2");
        },

        alerta(e, l) {
            if (l == "bien") {
                (this.aalert.estado = true),
                    (this.aalert.color = "success"),
                    (this.aalert.nombre = e);

                this.ejecucion = true;
                this.newwnuevo();
            }

            if (l == "error") {
                (this.aalert.estado = true),
                    (this.aalert.color = "error"),
                    (this.aalert.nombre = e);

                this.ejecucion = true;
            }
        },

        // Un método que se llama cuando se hace clic en un botón que muestra una tabla con datos.
        actualiza_tb_ver() {
            this.acti_tb_data = !this.acti_tb_data;
            this.filtro();
        },

        async filtro() {
            var headers = this.$store.getters.GetheadersAxios
            await this.$axios.get(this.$hostname + this.$hName + "/fechaVencimiento", { headers: headers })
                .then(res => { this.list = res.data; });
        },
    },

    computed: {
        ActDescBtn() {
            if (this.FechaVencimiento.codigo > 0) {
                this.EstadoBtn = {
                    BarraTablaDinamicaAprir: true,
                    nuevo: true,
                    guardar: false,
                    eliminar: true,
                    anular: false,
                    imprimir: false,
                    vercuenta: false,
                    guardartemporal: false,
                    restaurartemporal: false,
                    importarDato: false,
                    cargarProducto: false,
                    ImprimirproductoInv: false,
                    etiquetaXfactura: false
                }
            }

            if (this.FechaVencimiento.codigo <= 0) {
                this.EstadoBtn = {
                    BarraTablaDinamicaAprir: true,
                    nuevo: true,
                    guardar: true,
                    eliminar: false,
                    anular: false,
                    imprimir: false,
                    vercuenta: false,
                    guardartemporal: false,
                    restaurartemporal: false,
                    importarDato: false,
                    cargarProducto: false,
                    ImprimirproductoInv: false,
                    etiquetaXfactura: false
                }
            }
            this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
        }
    }
};
</script>

<style></style>